import { render, staticRenderFns } from "./BudgetTotalsCards.vue?vue&type=template&id=ca1da2fe&"
import script from "./BudgetTotalsCards.vue?vue&type=script&lang=js&"
export * from "./BudgetTotalsCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports